var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnClose(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icn_close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kapital_presentation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Backgroundstory_Initial_Mobile-360_PH_Version3.2",
    transform: "translate(-159.000000, -657.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icn_close",
    transform: "translate(159.000000, 657.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(11.000000, 11.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.70710678,0.292893219 L9.131,7.717 L16.5563492,0.292893219 C16.9168331,-0.0675907428 17.4840642,-0.0953202783 17.8763554,0.209704612 L17.9705627,0.292893219 C18.361087,0.683417511 18.361087,1.31658249 17.9705627,1.70710678 L17.9705627,1.70710678 L10.546,9.131 L17.9705627,16.5563492 C18.361087,16.9468735 18.361087,17.5800385 17.9705627,17.9705627 C17.5800385,18.361087 16.9468735,18.361087 16.5563492,17.9705627 L9.131,10.546 L1.70710678,17.9705627 C1.34662282,18.3310467 0.779391764,18.3587762 0.387100557,18.0537514 L0.292893219,17.9705627 C-0.0976310729,17.5800385 -0.0976310729,16.9468735 0.292893219,16.5563492 L0.292893219,16.5563492 L7.717,9.131 L0.292893219,1.70710678 C-0.0976310729,1.31658249 -0.0976310729,0.683417511 0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnClose);
export default __webpack_public_path__ + "static/media/icn_close.aa7917d3b754f529e9a16a8e4cdfb83e.svg";
export { ForwardRef as ReactComponent };